import { AxiosError } from "axios";
import { BodyPostLevel, ResponseLevel } from "./interfaceLevel";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";

export const getLevel = async (): Promise<ResponseLevel[]> => {
    try {
        const data = await getApi('/level');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseLevel[];
    }
}

export const postLevel = async (body: BodyPostLevel): Promise<ResponseLevel> => {
    try {
        const data = await postApi('/level', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseLevel;
    }
}

export const patchLevel = async (body: BodyPostLevel, id?:number): Promise<ResponseLevel> => {
    try {
        const data = await patchApi(`/level/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseLevel;
    }
}


export const getLevelId = async (term?: number): Promise<ResponseLevel> => {
    try {
        const data = await getApi(`/level/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseLevel;
    }
}

export const deleteLevel = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/level/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}
